import React from 'react';
import PropTypes from 'prop-types';

import { Collapse, TableCell, TableRow } from '@mui/material';

import OnEditIcon from '../../../icons/OnEditIcon';
import OnWarningIcon from '../../../icons/OnWarningIcon';
import { formatDate } from '../../../utils/dateFunctions';

import CourseInstanceDetails from './CourseInstanceDetails';

import classes from '../../../commonStyles/tables.module.css';

const styles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const CourseInstanceTableRow = ({
    row,
    isDisabled,
    isAttendanceAccessDisabled,
    isSelfEmployedCoach,
    toggleDropdown,
    openId,
    onEditRow
}) => {

    const onToggleDropdown = () => toggleDropdown(openId === row.id ? '' : row.id);

    return (
        <>
            <TableRow
                hover
                className={`${classes.tableRowStripes} ${classes.canOpen}`}
                onClick={onToggleDropdown}>
                <TableCell>{row.code}</TableCell>
                <TableCell>{row.name}</TableCell>
                <TableCell className={classes.rowWarningIcon}>
                    {!row.active ? (
                        <OnWarningIcon
                            tooltipContent="Missing Module Date"
                            customClass="blueIcon"
                        />
                    ) : (
                        ''
                    )}
                </TableCell>
                <TableCell>{formatDate(row.endDate) || ' - '}</TableCell>
                <TableCell>{formatDate(row.startDate) || ' - '}</TableCell>
                <TableCell align="right">
                    <OnEditIcon onEdit={(e) => onEditRow(e, row)} active={!isDisabled} />
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={styles} colSpan={6}>
                    <Collapse in={openId === row.id} timeout="auto" unmountOnExit>
                        <CourseInstanceDetails
                            row={row}
                            onClose={onToggleDropdown}
                            isDisabled={isDisabled}
                            isAttendanceAccessDisabled={isAttendanceAccessDisabled}
                            isSelfEmployedCoach={isSelfEmployedCoach}
                        />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

CourseInstanceTableRow.propTypes = {
    row: PropTypes.object,
    openId: PropTypes.string,
    toggleDropdown: PropTypes.func,
    isDisabled: PropTypes.bool,
    isAttendanceAccessDisabled: PropTypes.bool,
    isSelfEmployedCoach: PropTypes.bool,
    onEditRow: PropTypes.func
};

export default CourseInstanceTableRow;
